import React from 'react'
import classes from './style.module.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import useStyles from 'isomorphic-style-loader/useStyles'

import withSource from '../../../../hocs/source-scoll'

export default withSource(
    props => {
        useStyles(classes)
        const { href, title, src, lazy, width, height, innerRef, sensors } = props
        let aspectRatio
        if (width && height) {
            aspectRatio = `${Math.floor(height * 100 / width)}%`
        }
        return <a ref={innerRef}
            data-position={`${sensors?.position}`}
            data-type={sensors?.type}
            data-content={sensors?.content}
            data-title={sensors?.title}
            className={classes.ImageBlock} href={href}>
            <div className={classes.Image} style={{ paddingTop: aspectRatio }}>
                {
                    lazy ? <LazyLoadImage style={{ position: aspectRatio ? 'absolute' : 'static' }} alt={title} src={src} /> : <img style={{ position: aspectRatio ? 'absolute' : 'static' }} alt={title} src={src} />
                }
            </div>
        </a>
    }
)